import { TableGroup } from "src/app/components/default/table/table-group";

export function getTableGroupAmount(root: TableGroup, variant: "all" | "loaded" = "all", parenthidden = false): { visible: number; total: number } {
  let visible = 0;
  let total = 0;

  for (const group of root.groups) {
    const result = getTableGroupAmount(group, variant, parenthidden || root.hidden);
    visible += result.visible;
    total += result.total;
  }

  for (const row of root[variant === "all" ? "rows" : "loaded"]) {
    total += 1;
    if (!row.hidden && !root.hidden && !parenthidden) visible += 1;
  }

  return { visible, total };
}
